<div *ifScreenSize="screenType.Desktop" class="full-page login-banner w-100">
  <div class="full-container">
    <div>
      <img class="shared-login-banner d-lg-block d-none" alt="" draggable="false" src="assets/images/logos/NYJLogo.png" />
    </div>
    <div>
      <div class="container">
        <h2 class="text-secondary text-uppercase my-2 my-lg-2">{{ 'login.page.title' | translate }}</h2>
        <div class="text-secondary panel-text my-lg-2 mlb-text font-size-14">
          {{ 'login.page.description' | translate }}
        </div>
        <fgb-user-login></fgb-user-login>

        <ul class="footer-links">
          <li class="footer-link">
            <a href="{{ 'footer.privacy.link.url' | translate }}">
              <div class="privacy-link font-size-14">{{ 'footer.privacy.link' | translate }}</div>
            </a>
          </li>
          <li class="footer-link">
            <a href="{{ 'footer.your.privacy.link.url' | translate }}">
              <div class="privacy-link font-size-14">
                {{ 'footer.your.privacy.link' | translate }}
              </div>
            </a>
          </li>
          <li class="footer-link">
            <!-- OneTrust Cookies Settings button start -->
            <a class="privacy-link font-size-14 ot-sdk-show-settings">Cookie Settings</a>
            <!-- OneTrust Cookies Settings button end -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<div *ifScreenSize="screenType.Mobile" class="login-banner mobile-page">
  <div class="login-container">
    <div class="d-flex align-items-center justify-content-center">
      <span *ifScreenSize="screenType.Mobile">
        <img src="assets/images/logos/NYJLogo.png" class="logo" />
      </span>
    </div>
    <div class="bg-white content-login rounded-4">
      <h2 class="text-secondary text-uppercase my-2 my-lg-2">{{ 'login.page.title' | translate }}</h2>
      <div class="text-secondary panel-text mb-2 my-lg-2 mlb-text font-size-14">
        {{ 'login.page.description' | translate }}
      </div>
      <div class="w-100">
        <fgb-user-login></fgb-user-login>

        <ul class="footer-links">
          <li class="footer-link">
            <a href="{{ 'footer.privacy.link.url' | translate }}">
              <div class="privacy-link font-size-14">{{ 'footer.privacy.link' | translate }}</div>
            </a>
          </li>
          <li class="footer-link">
            <a href="{{ 'footer.your.privacy.link.url' | translate }}">
              <div class="privacy-link font-size-14">
                {{ 'footer.your.privacy.link' | translate }}
              </div>
            </a>
          </li>
          <li class="footer-link">
            <!-- OneTrust Cookies Settings button start -->
            <a class="privacy-link font-size-14 ot-sdk-show-settings">Cookie Settings</a>
            <!-- OneTrust Cookies Settings button end -->
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
